module.exports = __webpack_public_path__ + "img/loginBg.1f997c6a.png";